import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Button, CircularProgress, Typography } from "@mui/material";

import APP_ROUTES from "../../../../../routers/routeConstants";

import PostCard from "../../../../Feeds/components/Posts";
import { useUserActivities } from "../../../../User/api/queries/useUserActivities";
import { ActivityType } from "../../../../User/api/services/activities.service";

import NoActivityFigure from "../../../assets/images/entity-no-activity-figure.png";

const EntityActivity = ({ userId, isLoading }: { userId: string; isLoading: boolean }) => {
  const { t } = useTranslation("profiles", { keyPrefix: "activity" });
  const { data, isLoading: isActivitiesLoading } = useUserActivities(userId, ActivityType.all);
  const post = data?.posts[0];

  const isDataLoading = isLoading || isActivitiesLoading;
  return (
    <Box sx={styles.container}>
      <Typography variant="h6" sx={styles.title}>
        {t("activity")}
      </Typography>
      {isDataLoading && <CircularProgress sx={styles.loading} />}
      {post && !isDataLoading && <PostCard key={post.id} post={post} onClickOnMedia={() => {}} />}
      {!post && !isDataLoading && <NoActivity />}
    </Box>
  );
};

export default EntityActivity;

const NoActivity = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "activity" });
  const navigate = useNavigate();
  const handleAddActivity = () => navigate(APP_ROUTES.CREATE_POST);

  return (
    <Box sx={styles.noActivityContainer}>
      <Box component="img" src={NoActivityFigure} alt="no activity" sx={styles.noActivityFigure} />
      <Typography sx={styles.noActivity}>{t("noActivity")}</Typography>
      <Button variant="primary-md" onClick={handleAddActivity} sx={styles.addActivity}>
        {t("addActivity")}
      </Button>
    </Box>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    padding: "20px",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "var(--White, #FFF)",
  },
  title: {
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "24px",
    color: "var(--black-100, #1C1C1C)",
  },
  noActivityContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
  },
  noActivity: {
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    color: "var(--Dark---1000, #111)",
  },
  noActivityFigure: {
    width: "82.308px",
    height: "65.131px",
  },
  addActivity: {
    width: "fit-content",
  },
  loading: {
    margin: "0 auto",
  },
};
